import { Injectable } from '@angular/core';
import { DateRange } from '@angular/material/datepicker';
import { DateRangePickerPresetId, generateRange } from './date-range-preset';

@Injectable({
  providedIn: 'root'
})
export class DateRangePickerService {

  timezone: string = "Europe/Paris"; // default timezone

  defaultDateRange(timezone: string): DateRange<Date> {
    this.timezone = timezone;
    return generateRange(DateRangePickerPresetId.last30days, timezone);
  }

  currentDateRange: DateRange<Date> = this.defaultDateRange(this.timezone);
  
  constructor() {
  }

}

